"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nardo": {
    "de374ffd": [{
      "hkey": "9e69e3f2",
      "slug": "santa-caterina-cenate",
      "name": "Santa Caterina-Cenate",
      "primary": true,
      "skipSearch": false
    }],
    "cenate": [{
      "hkey": "9e69e3f2",
      "slug": "santa-caterina-cenate",
      "name": "Santa Caterina-Cenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nardo"
    }],
    "0ac818c1": [{
      "hkey": "3e3f0cab",
      "slug": "gallipoli-pagani",
      "name": "Gallipoli-Pagani",
      "primary": true,
      "skipSearch": false
    }],
    "pagani": [{
      "hkey": "3e3f0cab",
      "slug": "gallipoli-pagani",
      "name": "Gallipoli-Pagani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5e8a62f0": [{
      "hkey": "c963e3b6",
      "slug": "boncore",
      "name": "Boncore",
      "primary": true,
      "skipSearch": false
    }],
    "s-isidoro-boncore": [{
      "hkey": "c963e3b6",
      "slug": "boncore",
      "name": "Boncore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8d097522": [{
      "hkey": "9e69e3f2",
      "slug": "santa-caterina-cenate",
      "name": "Santa Caterina-Cenate",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina": [{
      "hkey": "9e69e3f2",
      "slug": "santa-caterina-cenate",
      "name": "Santa Caterina-Cenate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;